import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Mask } from '../../lib/components/LessonPath/static/style';
import request from '../../lib/request';
import utils from '../../lib/utils';

import { reqAPI } from '../../server/reqAPI';
import { abnormalReporting } from '../../server/commonFun';
import { ContentBox, ContentClose, ButtonBox, Button } from './static/style';

export default class ChooseLevel extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            levelInfo: props.data,
            userLevel: '',
            userLevelId: 0,
            showAllLevel: false,
        };
    }

    // 点击弹窗
    clickContentHandler(e) {
        let { userLevel, userLevelId, showAllLevel } = this.state;

        showAllLevel = false;

        if (e && e.target && e.target.id) {
            if (e.target.id === 'open') {
                showAllLevel = true;
            } else {
                if (e.target.getAttribute('value')) {
                    userLevel = e.target.getAttribute('value');
                    userLevelId = e.target.id;
                }
            }
        }

        this.setState({ userLevel, userLevelId, showAllLevel });
    }

    // 开通课程
    handleOpenCourse() {
        const { userLevelId } = this.state;
        const { successChooseLevelHandler } = this.props;

        request(reqAPI.open_course, Object.assign({}, this.context.user, { level: userLevelId }), { method: 'GET' })
            .then(res => res.json())
            .then(res => {
                if (res.code === 200) {
                    utils.showTips('恭喜您，开通成功', 1500, () => {
                        if (successChooseLevelHandler && typeof successChooseLevelHandler === 'function') {
                            successChooseLevelHandler();
                        }
                    })
                } else {
                    abnormalReporting({
                        putaoid: this.context.user.putaoid,
                        url: reqAPI.open_course,
                        type: 'data',
                        res
                    });
                }
            })
            .catch((err) => {
                abnormalReporting({
                    putaoid: this.context.user.putaoid,
                    url: reqAPI.open_course,
                    type: 'request',
                    err
                });
            });
    }

    render() {
        const { levelInfo, userLevel, showAllLevel } = this.state;
        return (
            <Mask>
                <ChooseLevelBox width='7.6rem' height='7.9rem' image='choose-level-bg' onClick={e => { this.clickContentHandler(e) }}>
                    <Title>确认开通</Title>
                    <Text>宝贝目前共有<span>{levelInfo.residueCourseNum}节数</span>，选择入学学习起点</Text>
                    <LevelString id='open' open={showAllLevel} >
                        {userLevel ? userLevel
                            : (levelInfo.levelAdvice && levelInfo.levelAdvice[0]
                                ? getKey(levelInfo.levelAdvice[0])
                                : userLevel
                            )}
                        {showAllLevel &&
                            <LevelBox>
                                {levelInfo.levelAdvice && Array.isArray(levelInfo.levelAdvice) && levelInfo.levelAdvice.map((item, index) =>
                                    <LevelItem id={getValue(item)} value={getKey(item)} key={index}>
                                        {getKey(item)}
                                    </LevelItem>
                                )}
                            </LevelBox>
                        }
                    </LevelString>
                    <Tips>
                        <li>Level K 适合启蒙或零基础的孩子</li>
                        <li>Level 1 适合小学1年级-2年级的孩子</li>
                        <li>Level 2 适合小学2年级-3年级的孩子</li>
                        <li>Level 3 适合小学2年级-4年级的孩子</li>
                    </Tips>
                    <NewButtonBox>
                        <SureButton
                            type='left'
                            onClick={() => this.handleOpenCourse()}
                        >
                            确认开通
                        </SureButton>
                    </NewButtonBox>
                    <ContentClose onClick={() => { this.props.clickCloseHandler() }} />
                </ChooseLevelBox>
            </Mask>
        );
    }
}

ChooseLevel.contextTypes = {
    user: PropTypes.object
}

const getKey = (item) => {
    if (!item || (item && item.length > 1)) {
        console.log('item 不合法，需要长度为一的对象');
        return;
    } else {
        for (let key in item) {
            return key;
        }
    }
}

const getValue = (item) => {
    if (!item || (item && item.length > 1)) {
        console.log('item 不合法，需要长度为一的对象');
        return;
    } else {
        for (let key in item) {
            return item[key];
        }
    }
}

const ChooseLevelBox = styled(ContentBox)`
    padding: 0 0.5rem 0.4rem 0.7rem;
    box-sizing: border-box;
    text-align: left;
`;

const Title = styled.div`
    /* margin: 2.42rem auto 0.38rem; */
    margin: 2.32rem auto 0.28rem;
    font-weight:500;
    font-size: 0.4rem;
    text-align: center;
`;

const Text = styled.div`
    font-size: 0.28rem;
    color: #464646;

    >span {
        color: #FF5F5F;
    }
`;

const NewButtonBox = styled(ButtonBox)`
    bottom: 0.3rem;
`;

const SureButton = styled(Button)`
    left: 0;
    width: 6.3rem;
    text-align: center;
`;

const LevelString = styled.div`
    position: relative;
    width: 6.3rem;
    height: 0.97rem;
    border: 0.01rem solid #DCD7E6;
    border-radius: 0.16rem;
    line-height: 0.97rem;
    margin-top: 0.2rem;
    z-index: 10;
    cursor: pointer;
    padding-left: 0.3rem;

    &::after {
        position: absolute;
        content: '';
        display: block;
        top: 0.3rem;
        right: 0.3rem;
        width: 0.5rem;
        height: 0.26rem;
        background: url(${require('./static/img/row.png')}) no-repeat center;
        background-size: contain;

        ${props => props.open ? `
            transform: rotateZ(180deg);
            -webkit-transform: rotateZ(180deg);
        ` : ''}
    }
`;


const LevelBox = styled.ul`
    position: absolute;
    top: 1.1rem;
    left: 0;
    width: 100%;
    height: 4rem;
    padding: 0 0.33rem;
    border: 0.01rem solid #DCD7E6;
    border-radius: 0.1rem;
    background: #fff;
    /* overflow: scroll;
    -ms-overflow-style: none;
    overflow: -moz-scrollbars-none;

    &::-webkit-scrollbar {
        width: 0 !important;
    } */
`;

const LevelItem = styled.li`
    border-bottom: 0.01rem solid #DCD7E6;
    line-height: 0.97rem;
    height: 0.97rem;
    color: #464646;
`;

const Tips = styled.ul`
    color: #8C8C8C;
    font-size: 0.2rem;
    list-style: disc;
    margin-left: 0.5rem;
    line-height: 0.4rem;
`;


// WEBPACK FOOTER //
// ./src/components/dialog/ChooseLevel.js